import { Dispatch, useEffect, useMemo } from 'react';
import { connect, useDispatch } from 'react-redux';

import { Button } from 'UIPackage/MainModule/components/Button';
import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';
import { RootActions } from 'CorePackage/MainModule/types/RootActions';
import { decisionGetSignedHistoryChanges } from 'DecisionPackage/MainModule/actions/decisionActions';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';
import { getDecisionSignedHistoryChanges } from 'DecisionPackage/MainModule/selectors/decisionSelectors';
import { IKnmHistoryChanges } from 'KnmPackage/MainModule/interfaces/IKnmHistoryChanges';
import { KnmHistory } from 'KnmPackage/KnmHistoriesModule/components/KnmHistory';
import { knmGetSignedHistoryChanges } from 'KnmPackage/MainModule/actions/knmActions';
import { getKnmSignedHistoryChanges } from 'KnmPackage/MainModule/selectors/knmSelectors';

import styles from './KnmSignedHistoryModal.module.scss';

export interface IHistoryData {
  startDateTime: string;
  endDateTime: string;
}

interface IKnmSignedHistoryModalProps {
  onClose: () => void;
  data: IHistoryData;
  isDecision: boolean;
}

interface IKnmSignedHistoryModalStoreProps {
  decisionSignedHistoryChanges: IKnmHistoryChanges | undefined;
  knmSignedHistoryChanges: IKnmHistoryChanges | undefined;
}

const KnmSignedHistoryModalWithoutStore = ({
  onClose,
  isDecision,
  data,
  decisionSignedHistoryChanges,
  knmSignedHistoryChanges,
}: IKnmSignedHistoryModalProps & IKnmSignedHistoryModalStoreProps) => {
  const dispatch = useDispatch<Dispatch<RootActions>>();

  useEffect(() => {
    if (isDecision) {
      dispatch(decisionGetSignedHistoryChanges(data.startDateTime, data.endDateTime));
    } else {
      dispatch(knmGetSignedHistoryChanges(data.startDateTime, data.endDateTime));
    }
  }, []);

  const historyChanges = useMemo(() => {
    return isDecision ? decisionSignedHistoryChanges : knmSignedHistoryChanges;
  }, [isDecision, decisionSignedHistoryChanges, knmSignedHistoryChanges]);

  return (
    <Modal visible={true} onClose={onClose}>
      <div className={styles.ModalHeader}>
        <ModalHeader title={'История изменения'} sizeText="medium" weight="bold" placement="centre" />
      </div>
      <ModalBody size="content" overflow="scroll">
        <KnmHistory id={'signed-history'} title={''} loading={false} historyChanges={historyChanges?.main || []} />
      </ModalBody>
      <ModalActions>
        <Button text="Отмена" id="closeBtn" color="default" size="medium" onClick={onClose} />
      </ModalActions>
    </Modal>
  );
};

const mapStateToProps = (state: IRootState): IKnmSignedHistoryModalStoreProps => ({
  decisionSignedHistoryChanges: getDecisionSignedHistoryChanges(state),
  knmSignedHistoryChanges: getKnmSignedHistoryChanges(state),
});

export const KnmSignedHistoryModal = connect(mapStateToProps)(KnmSignedHistoryModalWithoutStore);
